import React from 'react';
import { Row, Col } from 'src/componentes/grid';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import Input from 'src/componentes/input';
import StatusLookup from 'src/lookups/status-organizacao';
import TipoLookup from 'src/lookups/tipo-organizacao';
import ColaboradorSimplificadoLookup from 'src/lookups/ColaboradorSimplificadoLookup';
import { capitalizeFirstLetter } from 'src/utils/string';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import TagLookup from 'src/lookups/TagLookup';

class OrganizacaoSearch extends React.Component {
  render() {
    let { model, resources, intl, configuracao } = this.props;

    return (
      <>
        <Row>
          <Col md={12}>
            <Input model={model.getModel('nome')} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ColaboradorSimplificadoLookup
              model={{
                label: capitalizeFirstLetter(resources.responsavel),
                value: model.getModel('responsavel').value,
                requestChange: model.getModel('responsavel').requestChange,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <StatusLookup clearable={true} model={model.getModel('status')} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TipoLookup model={model.getModel('tipo')} clearable={true} />
          </Col>
        </Row>
        <Row>
          {configuracao?.utilizarSubordinacaoMatricial && (
            <Col md={12}>
              <ItemOrganizacaoLookup
                multi={true}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'subordinacaoMatricial' })
                  ),
                  value: model.getModel('subordinacaoMatricial').value,
                  requestChange: model.getModel('subordinacaoMatricial')
                    .requestChange,
                }}
                data={{ tiposIdSelecionaveis: [1, 2] }}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col md={12}>
            <TagLookup
              multi
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'tags' }, { tags: resources.tags })
                ),
                value: model.getModel('tags').value,
                requestChange: model.getModel('tags').requestChange,
              }}
              data={{ funcionalidadesIdSelecionaveis: [12] }}
            />
          </Col>
        </Row>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(OrganizacaoSearch));
